import { useContext, useCallback } from 'react'
import { FronthubContext as MicrofrontendContext } from 'front-hub-context-api'
import { CONTEXT } from '../../../../constants'
import { dispatch } from '../../instrumentation-api/core'
import {
  LogLevelNames,
  LogLevelDefaultName,
} from '../../instrumentation-api/log-levels'
import { InstrumentationTypes } from '../../instrumentation-api/instrumentation-types'
import { isError } from '../../../../core/object'

const defaultOptions = {
  group: 'default',
  tracePerformance: false,
}

const buildTrackHandler = (configuration, hookOptions, metadata) =>
  useCallback((name, payload = {}, options = {}) => {
    dispatch(
      {
        type: InstrumentationTypes.track,
        name,
        payload,
        options: {
          ...hookOptions,
          ...options,
        },
        metadata,
      },
      configuration,
    )
  })

const buildLogHandler = (configuration, level, hookOptions, metadata) =>
  useCallback((message, options = {}) => {
    const context = {
      type: InstrumentationTypes.log,
      message,
      level,
      options: {
        ...hookOptions,
        ...options,
      },
      metadata,
    }

    if (isError(message)) {
      context.message = message.message
      context.error = message
    }

    dispatch(context, configuration)
  })

const useInstrumentation = (options = defaultOptions) => {
  const { [CONTEXT]: frontHubContext } = useContext(MicrofrontendContext)
  const {
    manifestInstance: { name, version, key },
    configuration,
  } = frontHubContext
  const metadata = {
    microfrontend: {
      name,
      version,
      key,
    },
  }

  return {
    [InstrumentationTypes.track]: buildTrackHandler(
      configuration,
      options,
      metadata,
    ),
    [InstrumentationTypes.log]: buildLogHandler(
      configuration,
      LogLevelDefaultName,
      options,
      metadata,
    ),
    ...LogLevelNames.reduce(
      (acc, level) => ({
        ...acc,
        [String(level)]: buildLogHandler(
          configuration,
          level,
          options,
          metadata,
        ),
      }),
      {},
    ),
  }
}

export default useInstrumentation
